import React from "react"
import {
	Container, Row, Col, Card, CardTitle, CardText, CardImg
} from "reactstrap"
import {Link} from "react-router-dom"
import {URL} from "../config"

//layouts
import ToursCarousel from "./layouts/ToursCarousel"
import BookModal from "./layouts/BookModal"
import IterinaryModal from "./layouts/IterinaryModal"

import "../animate.css"
// import "./styles_components/Home.css"


const Home = ({products, user, token}) => {
	// console.log(products)



	const showProducts = products.map(product =>(
		<Col sm="6" key={product._id} className="mb-5 mx-auto">
			<Card className="borderRadius shadow-lg p-3 mb-5 bg-white fontSizez animated fadeInUp slower">
				<div>
					{ user && token && user.isAdmin === true ?
						<Link to={`/tours/${product._id}`}>
							<CardTitle>
								<h4 className="mb-3">{product.name}</h4>
							</CardTitle>
						</Link> 
						:
						<CardTitle>
							<h4 className="mb-3">{product.name}</h4>
						</CardTitle>
					}

					<div className="home-marginz">
						<CardImg src={`${URL}/${product.image}`} height="300" />
					</div>

					<div>
						<CardText className="text-justify">{product.description}</CardText>
					</div>

					<div className="my-4">
						<CardText className="form-inline justify-content-center">
							<h5 className="mr-1">PHP</h5>
							<h5>{product.price}</h5>
						</CardText>
					</div>
				</div>
				
				{ user && token && user.isAdmin === false ? //admin restriction
				<div className="card-footer text-center">
					<div className="row">
						<div className="col-6">
							<IterinaryModal product={product} />
						</div>
						<div className="col-6">
							<BookModal product={product} />
						</div>
					</div>
				</div> : null }

			</Card>
		</Col>
	))

	return(
		<div className="tours-background">
		<Container>
			<Row className="d-flex justify-content-center pt-4">
				<Col className="pt-5">
					<ToursCarousel />
				</Col>
			</Row>

			<Row className="my-5">
				<Col className="text-center">
					<h2>Tours</h2>
				</Col>
			</Row>

			<Row>
				{showProducts}
			</Row>
		</Container>
		</div>
	)
}

export default Home